enum ArticleComponentType {
  DEFAULT = 'default',
  BIG = 'big',
  MAIN = 'main',
  SEARCH = 'search',
  SIDE = 'side',
  RECOMMENDED = 'recommended',
}
export default ArticleComponentType


